export const comma = function (c) {
  return (c + '').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const short = function (value) {
  let p = Math.floor(value);
  let suff = p.toString().length / 3;
  var name = ["", "K", "M", "B", "T"];
  let pow, val;
  let suffFloor;
  
  if (suff <= 1) return (Math.round(p * 100) / 100).toString();

  suffFloor = Math.floor(suff);

  if (suff - suffFloor == 0) {
    suffFloor--;
  }

  pow = Math.pow(1000, suffFloor);
  val = value / pow;

  return (Math.round(val * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (name[suffFloor] || '');
}